Ext.define('SA.lq.view.GridSizer', {
    constructor({grid, layoutConsts, getPanelSize, getHeaderHeight}) {
        this.grid = grid;
        this.layoutConsts = layoutConsts;
        this.getPanelSize = getPanelSize;
        this.getHeaderHeight = getHeaderHeight;
    },

    resize() {
        if (!this.grid.hasColumns()) {
            return;
        }

        var panelHeight = this.getPanelSize().height,
            panelPaddingHeight = this.layoutConsts.paddingTop + this.layoutConsts.paddingBottom,
            panelHeaderHeight = this.getHeaderHeight(),
            gridTopMarginHeight = this.layoutConsts.bodyMarginTop,
            maxGridHeight = Math.max(0, panelHeight - panelPaddingHeight - panelHeaderHeight - gridTopMarginHeight);

        this.grid.setSize({width: this.grid.getTotalWidth(), height: maxGridHeight});
    }
});